import { Injectable, signal, inject } from '@angular/core';

import { Storage } from './storage';

@Injectable({
  providedIn: 'root'
})
export class Auth {
  private _token = signal<string>('');
  private _user = signal<any>(null);
  private storageService = inject(Storage);

  constructor() {
    if (typeof window !== 'undefined') {
      const savedUser = this.storageService.getItem('user');
      if (savedUser) {
        this._user.set(savedUser);
      }

      const savedToken = this.storageService.getItem('token');
      if (savedToken) {
        this._token.set(savedToken);
      }
    }
  }

  public get token(): string {
    return this._token();
  }

  public set token(token: string) {
    this.storageService.setItem('token', token);
    this._token.set(token);
  }

  public get user(): any {
    return this._user();
  }

  public set user(user: any) {
    this.storageService.setItem('user', user);
    this._user.set(user);
  }

  public logout() {
    this.storageService.clear();
    this._token.set('');
    this._user.set(null);
    window.location.href = '/login';
  }
}
